import { render, staticRenderFns } from "./ForumsCategory.vue?vue&type=template&id=333efdbc&"
import script from "./ForumsCategory.vue?vue&type=script&lang=js&"
export * from "./ForumsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports